import { useEffect } from 'react';

import clsx from 'clsx';
import { FormState, UseFormRegister, UseFormSetValue } from 'react-hook-form';

import TutorialLegend from '@event/components/TutorialModal';
import useRandomizedContent from '@event/hooks/useRandomizedContent';
import useEventTypesStore from '@event/store/useEventTypesStore';
import { useTutorialStore } from '@event/store/useTutorialStore';
import { CreateEvent } from '@event/types';
import useClientStore from '@utils/hooks/useClientStore';

import Description from './Description';

interface DescriptionSelectionProps {
  register: UseFormRegister<CreateEvent>;
  setValue: UseFormSetValue<CreateEvent>;
  formState: FormState<CreateEvent>;
  isTutorialEventDescription?: boolean;
}

const DescriptionSelection = ({
  register,
  setValue,
  formState,
  isTutorialEventDescription = false,
}: DescriptionSelectionProps) => {
  const { selectedEventType } = useEventTypesStore();
  const { eventTitle, eventDescription } = useRandomizedContent(
    selectedEventType,
    formState.isDirty,
  );

  const tutorialStore = useClientStore(useTutorialStore, (state) => state);

  useEffect(() => {
    setValue('description', eventDescription);
    setValue('name', eventTitle);
  }, [eventDescription, eventTitle, setValue]);

  return (
    <div
      className={clsx(
        'mb-4',
        isTutorialEventDescription &&
          'relative z-20 rounded-[16px] bg-brand-white-100',
      )}
    >
      {isTutorialEventDescription && (
        <TutorialLegend
          textBubble="Popisek klidně přepište, jestli se vám nelíbí."
          textHeadingCounter="3/5"
          textHeading="Popis události."
          onSubmit={() => {
            tutorialStore?.goToNextStep();
          }}
          className="bottom-[-378px] left-0"
        />
      )}
      <Description
        id={'description'}
        register={register}
        setValue={setValue}
        value={eventDescription}
        placeholder={'Popisek vám klidně prázdný necháme \u{1F600}'}
        isTutorialEventDescription={isTutorialEventDescription}
      />
    </div>
  );
};

export default DescriptionSelection;
